import { createUseStyles } from 'react-jss';
const useReverLoadingStyles = createUseStyles(() => ({
    container: {
        display: 'flex',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden'
    },
    logo: {
        position: 'absolute',
        top: '45%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    }
}));
export default useReverLoadingStyles;
